import BaseHttp from '@/plugins/baseHttp';
const getById = (notificationId,) => {
  return BaseHttp.get(`/notifications/${notificationId}`,);
};

const create = (form,) => {
  return BaseHttp.post('/notifications', form,);
};

const edit = (id,form,) => {
  return BaseHttp.patch(`/notifications/${id}`, form,);
};

const handleError = (error,) => {
  return BaseHttp.handleError(error,);
};

const uploadCSV = (csvData,) => {

  const formData = new FormData();
  formData.append('file', csvData.file, csvData.header.name,);

  return BaseHttp.post('/notifications/upload/csv', formData,);
};

const uploadImage = (imageData,) => {

  const formData = new FormData();
  formData.append('file', imageData.file, imageData.header.name,);

  return BaseHttp.post('/notifications/upload/image', formData,);
};

const deleteNotication = (notificationId,) => {
  return BaseHttp.delete(`/notifications/${notificationId}`,);
};

export default {
  getById,
  create,
  edit,
  handleError,
  uploadCSV,
  uploadImage,
  deleteNotication,
};

